import { ScreenSizes } from '../../../helpers/breakpoints';
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import styled from 'styled-components';
import { Theme } from '@routific/hive';
import { PANEL_BORDER_COLOR } from '../../../constants';

export enum JustifyContent {
  FLEX_START = 'flex-start',
  FLEX_END = 'flex-end',
  CENTER = 'center',
  SPACE_BETWEEN = 'space-between',
  SPACE_AROUND = 'space-around',
  SPACE_EVENLY = 'space-evenly',
  START = 'start',
  END = 'end',
  LEFT = 'left',
  RIGHT = 'right',
}

interface Props {
  visible: boolean;
  children?: React.ReactNode;
  footerAlignment?: JustifyContent; 
}

// Rendered height on medium+ screens: 16px padding top/bottom around a 32px button row,
// plus the 1px top border.
export const PANEL_FOOTER_HEIGHT = 65;

const Container = styled.div<{ $isScreenMedium: boolean, $footerAlignment: JustifyContent | undefined }>`
  width: 100%;
  padding: ${({ $isScreenMedium }) => ($isScreenMedium ? `${Theme.Spacing.mdSpacing}` : `${Theme.Spacing.smSpacing} ${Theme.Spacing.mdSpacing}`)};
  display: flex;
  justify-content: ${({ $footerAlignment }) => $footerAlignment || 'space-between'};

  align-items: center;
  flex-direction: row;
  border-top: 1px solid ${PANEL_BORDER_COLOR};
`;

const PanelFooter: React.FC<Props> = ({ visible, children, footerAlignment }) => {
  const isScreenMedium = useMediaQuery({ minWidth: ScreenSizes.md });

  if (!visible) {
    return null;
  }

  return (
    <Container $isScreenMedium={isScreenMedium} $footerAlignment={footerAlignment}>
      {children}
    </Container>
  );
};

export default PanelFooter;
